import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-064a7fae"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main-wrap van-hairline--bottom" }

import { Field } from 'vant'
import { computed } from 'vue'
import { sendSmsVerifyCode } from '@/apis/insurance'
import { commonErrorHandle } from '@/utils/error-handle'
import { useSmsVerify } from '@/compositions/useSmsVerify'
import { showToastLoading, clearToast } from '@/utils/tools'


export default /*#__PURE__*/_defineComponent({
  __name: 'jijia-verify-code-wrap',
  props: {
    code: { default: '' },
    policyNo: { default: '' }
  },
  emits: ['update:code'],
  setup(__props: any, { emit: emits }) {

const props = __props as { code: string, policyNo: string };




const smsInfo = useSmsVerify({
  api: sendSmsVerifyCode,
})
const sendMessageClass = computed(() => {
  if (smsInfo.timeValue.value && !smsInfo.sending.value) {
    return 'wait-btn-class'
  }
  return ''
})
const btnText = computed(() => {
  if (!smsInfo.hasSended.value || smsInfo.sending.value) {
    return smsInfo.hasSended.value ? '重新获取' : '获取验证码'
  }
  if (smsInfo.timeValue.value) {
    return `${smsInfo.timeValue.value}秒后重新获取`
  }
  return '重新获取'
})
function updateHandle(value: string) {
  emits('update:code', value)
}
async function onSendHandle() {
  if (smsInfo.timeValue.value) {
    return
  }
  showToastLoading()
  try {
    await smsInfo.sendSmsMessage({
      policy_no: props.policyNo,
    })
    clearToast()
  } catch (error) {
    commonErrorHandle(error)
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(Field), {
      class: "verify-code-field",
      type: "digit",
      "model-value": props.code,
      maxlength: "6",
      placeholder: "请填写验证码",
      "onUpdate:modelValue": updateHandle,
      rules: [
        {
          required: true,
          trigger: 'onBlur',
          message: '请输入验证码',
        },
      ]
    }, null, 8, ["model-value"]),
    _createElementVNode("div", {
      class: _normalizeClass(["send-message", _unref(sendMessageClass)]),
      onClick: onSendHandle
    }, _toDisplayString(_unref(btnText)), 3)
  ]))
}
}

})